import config from '../config'

var API_ROOT = config.API_ROOT

export default {
  // user
  register: `${API_ROOT}account/register`,
  getVerifyCode: `${API_ROOT}account/getVerifyCode`,
  deregister: `${API_ROOT}account/deregister`,
  login: `${API_ROOT}account/login`,
  identify: `${API_ROOT}account/identify`,
  getUser: `${API_ROOT}account/getUser`,
  changePassword: `${API_ROOT}account/password/change`,
  resetPassword: `${API_ROOT}account/password/reset`,
  changeEmail: `${API_ROOT}account/email/change`,
  logout: `${API_ROOT}account/logout`,
  checkUserExist: `${API_ROOT}account/checkExist`,
  // project
  createProject: `${API_ROOT}project/create`,
  modifyProject: `${API_ROOT}project/modify`,
  deleteProject: `${API_ROOT}project/delete`,
  getProjects: `${API_ROOT}projects`,
  getEndpoints: `${API_ROOT}project/endpoints`,
  checkProjectExist: `${API_ROOT}project/checkExist`,
  // analytic
  timeSeries: `${API_ROOT}analytic/timeseries`,
  topn: `${API_ROOT}analytic/topn`,
  //management
  getTotalCount: `${API_ROOT}management/totalCount`,
  getUsers: `${API_ROOT}management/users`,
  search: `${API_ROOT}management/search`,
  setUser: `${API_ROOT}management/setUser`,
  setProject: `${API_ROOT}management/setProject`
}



// WEBPACK FOOTER //
// ./src/api/resources.js